import React, { useCallback } from 'react';
import * as auth from 'ducks/auth';
import { Redirect, Route as ReactRoute } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { BASE_APP_PATH, LOGIN_PAGE } from './constants';
import { TermsAgreement } from 'new-design/components/TermsAgreement';

const LoginRoute = ({ component: Component, ...rest }) => {
  const { sessionID, termsInfo } = useSelector(auth.selectors);

  const renderHandler = useCallback(
    (props) => {
      if (sessionID && !termsInfo?.acceptRequired && !termsInfo?.termsChanged) {
        const fromLocation = props.location?.state?.from;
        const redirectTarget =
          fromLocation && fromLocation.pathname !== LOGIN_PAGE ? fromLocation : { pathname: BASE_APP_PATH };

        return <Redirect to={redirectTarget} />;
      }

      return (
        <>
          <Component {...props} />
          <TermsAgreement />
        </>
      );
    },
    [sessionID, termsInfo]
  );

  return <ReactRoute {...rest} render={renderHandler} />;
};

export { LoginRoute };
